
import './styles/components/_1_tg-banner.scss';
import iconSrc from './assets/tg_icon.svg';
import logoSrc from './assets/tg_logo.svg';
import { t } from 'i18next';

export default function TgBanner({
  href = "https://t.me/energo_business",
}) {
  return (
    <section className="tg-banner-section">
      <div className="container">
        <div className="tg-banner">
          <div className="tg-banner__icon">
            <img src={iconSrc} alt="Telegram" />
          </div>
          <div className="tg-banner__content">
            <p className="tg-banner__text">
              {t("tg::desc").split("\n").map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
            </p>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="tg-banner__btn"
            >
              <span>{t("tg::button")}</span>
              <img src={logoSrc} alt="" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
